export const ON = 1;
export const OFF = 2;
const IS_DEV = process.env.NODE_ENV === "development";

// Use this file (or generate it from a CMS) to use data to control which embeds are loaded, sitewide.
// Embeds are Inserted in header and footer in components/layout.js and can bne included from src/components/embeds.js
export default {
	ALL: ON,
	// Categories of embeds
	SIGNIN: ON,
	ADS: IS_DEV ? OFF : ON,
	TRACK: IS_DEV ? OFF : ON,
	DEBUG: IS_DEV ? OFF : ON,
	APIS: ON,

	// Individual Embeds
	AppleSignIn: OFF,
	Audigent: OFF,
	AmazonAds: OFF,
	FacebookConnect: ON,
	FacebookPixel: ON,
	GoogleAdsense: ON,
	GoogleAnalytics: ON,
	GoogleSignin: OFF,
	GooglePlaces: ON,
	IntercomChat: OFF,
	GoogleReCaptcha: ON,
	Lotame: OFF,
	OneTrust: IS_DEV ? OFF : ON,
	Playwire: OFF,
};
